import React from 'react';
import { CreditCard, Truck, Headphones } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: CreditCard,
      title: "Multiple Cards",
      description: "Pay with Multiple Credit Cards"
    },
    {
      icon: Truck,
      title: "FREE SHIPPING",
      description: "Within 60 days for an exchange"
    },
    {
      icon: Headphones,
      title: "Premium Support",
      description: "Outstanding premium support"
    }
  ];

  return (
    <section className="border-t border-gray-200 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-4">
                <feature.icon size={48} className="text-gray-700" />
              </div>
              <h3 className="font-bold text-lg mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
